import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import FilterPanel from '@/custom/components/organisms/FilterPanel'
import { Drawer } from '@material-ui/core'
import { SignalCellularNull } from '@material-ui/icons'

const SortbyCom = (props) => {
    const formikSearch = props.formikSearch
    const searchData = props.searchData
    const clearSearchFilter = props.clearSearchFilter
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    return (
        <div className="search customContainer">
            <div className="w-100 searchHead d-flex justify-content-between align-items-center flex-wrap">
                <Button
                    id="sortby_tune"
                    className="toggleRespDrawer"
                    variant="outlined"
                    onClick={toggleDrawer('bottom', true)}
                >
                    <span className="material-icons">tune</span>
                    {'filters'}
                </Button>
            </div>
            <div></div>
            <div className="searchMiscFilters w-100 mb-3 d-flex justify-content-end align-items-end">
                <div className="gridListToggle">
                    {props.grid ? (
                        <Button
                            id="sortby_apps"
                            className={formikSearch.values.auctionView === 'Grid' ? 'active' : ''}
                            onClick={() => formikSearch.setFieldValue('auctionView', 'Grid')}
                        >
                            <span className="material-icons">apps</span>
                        </Button>
                    ) : null}

                    {props.list ? (
                        <Button
                            id="sortby_view_list"
                            className={formikSearch.values.auctionView === 'List' ? 'active' : ''}
                            onClick={() => formikSearch.setFieldValue('auctionView', 'List')}
                        >
                            <span className="material-icons">view_list</span>
                        </Button>
                    ) : null}
                </div>
                {props.result_per_page ? (
                    <CustomSelect
                        label="Results per page"
                        name="resultsPerPage"
                        selectType="noBorder"
                        value={formikSearch.values.limit}
                        size="small"
                        onChange={(event, editor) => {
                            formikSearch.setFieldValue('limit', event.target.value)
                        }}
                    >
                        {searchData.pageOptions.map((opt, optindex) => (
                            <option value={opt.value}>{opt.show}</option>
                        ))}
                    </CustomSelect>
                ) : null}

                {props.sortby ? (
                    <CustomSelect
                        label="Sort by"
                        value={formikSearch.values.orderby}
                        size="small"
                        selectType="noBorder"
                        name="orderby"
                        // shrink={search.orderby !== '' ? true : false}
                        onChange={(event, editor) => {
                            formikSearch.setFieldValue('orderby', event.target.value)
                        }}
                    >
                        {searchData.sortShow.map((opt, optindex) => (
                            <option value={opt.value}>{opt.show}</option>
                        ))}
                    </CustomSelect>
                ) : null}
            </div>
            <div className="searchCnt d-flex justify-content-start align-items-start">
                {/* <div className="searchRt">
                    <div className="d-flex justify-content-between align-items-center"></div>
                    {isLoading ? (
                        <Loaders name="product_grid_view" isLoading={isLoading} loop={6} />
                    ) : viewProduct.length > 0 ? (
                        <>
                            <div className={`searchResults ${auctionView}`}>
                                <Drawer
                                    className="rightDrawer"
                                    anchor={'right'}
                                    open={state['right']}
                                    onClose={toggleDrawer('right', false)}
                                >
                                    <ProductView
                                        data={state.data}
                                        drawerHandler={toggleDrawer('right', false)}
                                    />
                                </Drawer>

                                {viewProduct.map((data, index) => (
                                    <>
                                        {formikSearch.values.auctionView === 'Grid' ? (
                                            <>
                                                <GridView
                                                    data={data}
                                                    favId={`searchProd_${index}`}
                                                    drawerHandler={toggleDrawer(
                                                        'right',
                                                        true,
                                                        data,
                                                    )}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <ListView
                                                    data={data}
                                                    favId={`searchProd_${index}`}
                                                    drawerHandler={toggleDrawer(
                                                        'right',
                                                        true,
                                                        data,
                                                    )}
                                                />
                                            </>
                                        )}
                                    </>
                                ))}
                            </div>

                            <div className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper">
                                <h6>
                                    {t('showing')} {search_allproducts.setDisp} {t('of')}{' '}
                                    {search_allproducts.totalRecords}
                                </h6>
                                <Pagination
                                    count={Math.ceil(
                                        search_allproducts.totalRecords / formikSearch.values.limit,
                                    )}
                                    page={formikSearch.values.page}
                                    onChange={onHandlePage}
                                    siblingCount={3}
                                    showFirstButton
                                    showLastButton
                                    boundaryCount={2}
                                />
                            </div>
                        </>
                    ) : (
                        <NoRecordsFound />
                    )}
                </div> */}
            </div>
        </div>
    )
}

export default SortbyCom
